<template>
  <div id="app">
    <fade-transition mode="out-in">
      <div v-if="generatingCard" class="loading-splash">
        <div class="loading-message">
          <h3>Üks moment - <br />kleebime kaarti kokku.</h3>
          <p>Jõulude ajal võta rahulikult!</p>
          <p>Kiirustamine ei vii kuhugi.</p>
        </div>
      </div>
    </fade-transition>

    <fade-transition mode="out-in">
      <router-view
        :avatar="avatar"
        :config="template"
        :finalImage="finalImage"
        :cardUrl="cardUrl"
        @submit="setValue"
        @camera="generatingCard = true"
        @back="activeStep--"
        @reset="reset"
      />
    </fade-transition>
  </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
import { uploadCard } from './firebase'

export default {
  name: 'app',
  data() {
    return {
      avatar: null,
      finalImage: null,
      activeStep: 0,
      template: null,
      cardUrl: '',
      generatingCard: false
    }
  },
  components: { FadeTransition },
  watch: {
    '$route.path': {
      immediate: true,
      handler(val) {
        if (val.startsWith('/upload') && !this.template) return this.$router.push('/')
        if (val.startsWith('/create') && !this.template && !this.avatar) return this.$router.push('/')
      }
    }
  },
  methods: {
    setValue(payload) {
      this[payload.name] = payload.value

      if (payload.name === 'finalImage') {
        this.generatingCard = true
        uploadCard(payload.value, this.$db, this.template.orientation, card => {
          this.$router.push(`/card/${card.name}?share`)

          setTimeout(() => {
            this.generatingCard = false
          }, 1000)
        })
      }
    },
    async reset(gallery = false) {
      this.avatar = null
      this.finalImage = null
      this.activeStep = 0
      this.template = {}
      this.cardUrl = ''
      this.quote = ''
      this.$router.push(gallery ? '/#gallery' : '/')
    }
  }
}
</script>

<style src="@/assets/styles/variables.css"></style>
<style src="@/assets/styles/global.css"></style>
<style src="@/assets/styles/fonts.scss" lang="scss"></style>
<style lang="scss">
#app {
  color: var(--main);
  min-height: 100vh;
  max-width: 60rem;
  margin: 0 auto;
}
.logo {
  position: sticky;
  top: 3vh;
  font-size: 3rem;
  pointer-events: none;
  color: white;
  z-index: 9;
  font-weight: 600;
  padding-left: 0.5rem;

  &.-sticky {
    top: 105vh;
  }
}
.scroll-cursor {
  cursor: url('/arrow-down.svg') 0 0, auto;
}
button,
.button {
  display: inline-flex;
  align-items: center;
  color: white;
  font-size: 32px;
  padding: 10px 20px;
  font-weight: bold;
  cursor: pointer;

  svg {
    height: 100%;
    margin: 0 1rem;
    fill: white;
    width: 2rem;
  }

  &:hover {
    color: var(--main);

    svg {
      fill: var(--main);
    }
  }
  &:focus {
    outline: none;
  }

  @media screen and (max-width: 20rem) {
    font-size: 22px;
  }
}
.button + .button {
  margin-left: 1rem;
}
.button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.instructions {
  margin-bottom: 2rem;
}
.loading-splash {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 4rem;
  background: var(--background);
  z-index: 8;
  padding: 0.5rem;
  width: 100vw;
}
.loading-message {
  text-align: left;

  h3 {
    max-width: 55rem;
    // padding-left: 5vw;
    font-weight: 900;
    // animation: pulseanim 1.6s infinite ease-in-out;
  }
  p {
    font-weight: 900;
    font-size: 0.925em;
    text-align: left;
    margin-top: 0.75rem;
  }

  @media screen and (max-width: 40rem) {
    font-size: 2rem;
  }
}
@keyframes pulseanim {
  0% {
    opacity: 0.4;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}
</style>
